import { useTranslation } from 'react-i18next';
import { CosmosBackdrop } from '../brand/CosmosBackdrop';
import styles from './ZodiacProgress12.module.css';

export interface ZodiacProgress12Props {
  signsDone: number;
  testId?: string;
}

export function ZodiacProgress12({
  signsDone,
  testId = 'zodiac-progress-12',
}: ZodiacProgress12Props): JSX.Element {
  const { t } = useTranslation('flows');
  const clamped = Math.max(0, Math.min(12, signsDone));
  const segments = Array.from({ length: 12 }, (_, i) => {
    if (i < clamped) return 'done' as const;
    if (i === clamped) return 'active' as const;
    return 'pending' as const;
  });

  return (
    <div className={styles.root} data-testid={testId}>
      <CosmosBackdrop />
      <div className={styles.count} aria-hidden="true">
        {clamped}/12
      </div>
      <p
        className={styles.label}
        aria-live="polite"
        data-testid="zodiac-progress-label"
      >
        {t('avatarFlow.zodiac.progress.label', { current: clamped, total: 12 })}
      </p>
      <div className={styles.segments} role="progressbar" aria-valuenow={clamped} aria-valuemin={0} aria-valuemax={12}>
        {segments.map((kind, i) => (
          <div
            key={i}
            className={
              kind === 'done'
                ? `${styles.segment} ${styles.segmentDone}`
                : kind === 'active'
                  ? `${styles.segment} ${styles.segmentActive}`
                  : styles.segment
            }
            data-testid={`zodiac-progress-seg-${i}-${kind}`}
          />
        ))}
      </div>
    </div>
  );
}
